(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/login.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/login.js');

'use strict';

const {
  ErrorTypes
} = svs.accountservices.authenticate.definitions;
const {
  NEW_CUSTOMER,
  LOGIN,
  ERROR,
  ONE_RETRY_LEFT
} = svs.accountservices.authenticate.definitions.Events;
svs.player_login.behaviors.Login = Marionette.Behavior.extend({
  initialize() {
    var _this = this;
    this.newCustomerListener = function () {
      return _this.onNewCustomerLogin(...arguments);
    };
    this.loginListener = function () {
      return _this.onLogin(...arguments);
    };
    this.errorListener = function () {
      return _this.onLoginError(...arguments);
    };
    this.oneRetryLeftListener = function () {
      _this.view.model.set('oneRetryLeft', true);
    };
    this.authenticateEvents = {
      [NEW_CUSTOMER]: this.newCustomerListener,
      [LOGIN]: this.loginListener,
      [ERROR]: this.errorListener,
      [ONE_RETRY_LEFT]: this.oneRetryLeftListener
    };
    svs.accountservices.authenticate.login.on(this.authenticateEvents, this);
    svs.accountservices.utils.user.deleteStoredUserData();
  },
  onNewCustomerLogin(response) {
    const returnUrl = this.view.model.get('returnUrl');
    if (returnUrl) {
      response.returnUrl = returnUrl;
    }
    if (this.view.model.get('isPoker')) {
      svs.player_login.router.navigate("/poker/inte-kund?returnUrl=".concat(this.view.model.get('returnUrl')), true);
    } else {
      var _svs$components$Stora;
      response.depositValue = (_svs$components$Stora = svs.components.Storage) === null || _svs$components$Stora === void 0 || (_svs$components$Stora = _svs$components$Stora.browser) === null || _svs$components$Stora === void 0 || (_svs$components$Stora = _svs$components$Stora.get('depositValues', 'quick-deposit')) === null || _svs$components$Stora === void 0 ? void 0 : _svs$components$Stora.amount;
      svs.utils.form.postToUrl(svs.core.urlMapping.get('customerRegistrationCompletion'), response, 'POST');
    }
  },
  async onLogin(data) {
    this.view.model.set('lastLoginTime', data.lastLoginTime);
    this.view.model.set('firstNameLogin', "".concat(data.firstName));
    if (this.view.model.get('isPoker')) {
      if (svs.core.detect.feature('ft-playscan-pokermessage') && (await this.hasForcedPlayscanMessage())) {
        svs.player_login.router.navigate('/poker/spelansvar', true);
        return false;
      }
      this.view.model.set('accessToken', data.response.accessToken);
      this.view.model.set('returnUrl', svs.utils.url.join(this.view.model.get('returnUrl'), "&token_type=uri&access_token=".concat(data.response.accessToken)));
      svs.player_login.router.navigate("information/".concat(this.view.model.get('lastLoginTime'), "?client=poker&returnUrl=").concat(encodeURIComponent(this.view.model.get('returnUrl'))), true);
    } else {
      if (svs.core.detect.feature('ft-login-legal-info')) {
        window.location.href = "".concat(svs.core.urlMapping.get('legalInfo'), "?t=").concat(this.view.model.get('lastLoginTime'), "&returnUrl=").concat(encodeURIComponent(this.view.model.get('returnUrl')));
        return;
      }
      svs.player_login.router.navigate("information/".concat(this.view.model.get('lastLoginTime'), "?returnUrl=").concat(encodeURIComponent(this.view.model.get('returnUrl'))), true);
    }
  },
  onLoginError(err) {
    this.view.triggerMethod('before:error');

    if (err.type !== ErrorTypes.CANNOT_CANCEL) {
      switch (err.type) {
        case ErrorTypes.FREJA_NEW_CUSTOMER:
          {
            let targetUrl = svs.utils.url.join(svs.core.urlMapping.get('customerRegistrationHome'), 'freja/bli-kund');
            if (this.view.model.get('returnNewCustomer')) {
              targetUrl = "".concat(targetUrl, "?returnUrl=").concat(this.view.model.get('returnUrl'));
            }
            svs.utils.url.navigate(targetUrl);
            break;
          }
        case ErrorTypes.INVALID_TOKEN:
          svs.player_login.router.navigate('/', true);
          break;
        case ErrorTypes.LOGIN_USER_ABORTED:
          svs.player_login.logger.debug('Login aborted by user');
          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
            icon: 'login',
            type: svs.ui.dialog.type.ERROR,
            title: 'Inloggning avbruten',
            message: [{
              type: svs.ui.dialog.message.TEXT,
              text: 'Inloggningen avbröts.'
            }],
            actions: [{
              title: 'Okej',
              callback: () => {
                svs.utils.url.navigate(this.view.model.get('cancelUrl'));
              }
            }]
          }));
          break;
        default:
          {
            const dialog = new svs.ui.dialog.Confirm({
              actions: [{
                callback: () => {
                  dialog.close();
                  this.view.triggerMethod('unblock:navigation');
                  this.view.triggerMethod('error');
                },
                title: 'Okej'
              }],
              area: svs.ui.dialog.area.POPUP,
              branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
              icon: 'login',
              message: [{
                text: err.message
              }],
              title: 'Det verkar inte gå att logga in just nu'
            });
            svs.ui.dialog.api.add(dialog);
          }
      }
    }
  },
  async hasForcedPlayscanMessage() {
    try {
      const {
        response
      } = await svs.core.jupiter.callAsync({
        method: 'POST',
        path: '/player/1/playscancustomerdata',
        data: {
          login: true
        }
      });
      if (response !== null && response !== void 0 && response.json) {
        const json = JSON.parse(response.json);
        return (json === null || json === void 0 ? void 0 : json.notification_method) === 'force';
      }
    } catch (e) {
      svs.player_login.logger.error('Error fetching playscan data', e);
    }
    return false;
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(this.authenticateEvents);
  }
});

 })(window);